import { render, staticRenderFns } from "./forecasting.vue?vue&type=template&id=4dacbcaa&scoped=true"
import script from "./forecasting.vue?vue&type=script&lang=js"
export * from "./forecasting.vue?vue&type=script&lang=js"
import style0 from "./forecasting.vue?vue&type=style&index=0&id=4dacbcaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dacbcaa",
  null
  
)

export default component.exports